(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["johncreations-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
    const link = document.getElementById('jc-whatsapp');
    if (!link) return;
    let frame = 0;
    const observedChatRoots = new WeakSet();
    const visibleRect = (element) => {
      if (!element || element.closest('[inert]') || !element.getClientRects().length) return null;
      const style = getComputedStyle(element);
      if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return null;
      const rect = element.getBoundingClientRect();
      return rect.width && rect.height ? rect : null;
    };
    const update = () => {
      frame = 0;
      const width = document.documentElement.clientWidth;
      const height = window.innerHeight;
      const chat = document.querySelector('shopify-chat');
      const roots = [];
      const collectRoots = (node) => {
        if (!node) return;
        roots.push(node);
        if (!observedChatRoots.has(node)) {
          observedChatRoots.add(node);
          node.addEventListener('transitionend', schedule, true);
          new MutationObserver(schedule).observe(node, {subtree:true,childList:true,attributes:true});
        }
        for (const child of node.querySelectorAll('*')) {
          if (child.shadowRoot) collectRoots(child.shadowRoot);
        }
        if (node.shadowRoot) collectRoots(node.shadowRoot);
      };
      collectRoots(chat);
      const activator = roots.map(root => root.querySelector('button[part="activator"]')).find(Boolean);
      const chatRect = visibleRect(activator);
      let right = 24;
      let bottom = 92;
      if (chatRect) {
        right = Math.max(12, width - chatRect.left - chatRect.width / 2 - 24);
        bottom = Math.max(92, height - chatRect.top - chatRect.height / 2 + 70 - 24);
      }
      const barriers = [...document.querySelectorAll('#shopify-pc__banner, #shopify-pc__prefs, cart-drawer.active, .cart-notification.active, details[open] .menu-drawer, .product-form__submit')];
      for (const root of roots) barriers.push(...root.querySelectorAll('[role="dialog"]'));
      let top = height - bottom - 48;
      const left = width - right - 48;
      const rects = barriers.map(visibleRect).filter(Boolean).sort((a,b)=>b.top-a.top);
      for (const rect of rects) {
        if (left < rect.right + 8 && left + 48 > rect.left - 8 && top < rect.bottom + 8 && top + 48 > rect.top - 8) top = rect.top - 60;
      }
      const unavailable = top < 12 || (activator && activator.getAttribute('aria-expanded') === 'true');
      if (link.hidden !== Boolean(unavailable)) link.hidden = Boolean(unavailable);
      const nextRight = Math.round(right) + 'px';
      const nextBottom = Math.round(height - top - 48) + 'px';
      if (link.style.right !== nextRight) link.style.right = nextRight;
      if (link.style.bottom !== nextBottom) link.style.bottom = nextBottom;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    new MutationObserver((changes) => {
      if (changes.some(change => change.target !== link && !link.contains(change.target))) schedule();
    }).observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['class','style','open','hidden','aria-expanded']});
    window.addEventListener('resize', schedule, {passive:true});
    window.addEventListener('scroll', schedule, {passive:true});
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, {passive:true});
    [100, 500, 1500, 3000].forEach(delay => setTimeout(schedule, delay));
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
